module.exports = __webpack_public_path__ + "img/kolibri-token.6d015abb.svg";